export default __webpack_public_path__ + "assets/images/investment-products.svg";